import "core-js/features/global-this";
import "script-loader!../content/js/system/jquery-2.1.4.js";
import "script-loader!../content/js/system/jquery.cookie.js";
import "script-loader!../content/js/bootstrap/bootstrap.js";
import "script-loader!../content/js/system/waves.js";
import "../Content/js/material/functions.js";
import "../Content/ts/helper/helper";
import "../Content/ts/helper/Helper.User";
import "../Content/ts/helper/Helper.String";
import "../Content/ts/helper/Helper.Url";
import "../Content/js/crm/Crm.Token.js";
import "../Content/js/Login.js";
